import { useNavigate, useParams } from 'react-router-dom'

import { ProjectDetail } from '@/features/projects/ProjectDetail'
import { isProjectWindow } from '@/features/projects/openProjectWindow'

/** `/projects/<id>`: one project, full page — in its own window when opened from the list,
 * in the ordinary shell when followed from a link elsewhere (workload, initiatives, WIG). */
export function ProjectPage() {
  const { projectId } = useParams<{ projectId: string }>()
  const navigate = useNavigate()
  const inWindow = isProjectWindow()

  if (!projectId) return null
  return (
    <ProjectDetail
      id={projectId}
      inWindow={inWindow}
      onClose={() => {
        // window.close() only works on a window a script opened — which this one was.
        if (inWindow) window.close()
        else navigate('/projects')
      }}
    />
  )
}
